import NiceModal, { useModal } from '@ebay/nice-modal-react';

import Button from 'components/field/Button';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent } from 'components/global/styled/Modal.styled';

import * as S from './VideoPreviewModal.styled';

const VideoPreviewModal = NiceModal.create(({ videoUrl, header, content, actionUrl, actionLabel }) => {
	const modal = useModal();
	const handleCloseModal = () => {
		modal.remove();
	};

	return (
		<Modal maxWidth="small" fullwidth closeButton className="modal-confirmation">
			<ModalContent className="pt-5">
				<S.ContentWrapper>
					{videoUrl && (
						<iframe
							width="100%"
							height="315"
							src={videoUrl}
							style={{ border: 'none' }}
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							referrerPolicy="strict-origin-when-cross-origin"
							allowFullScreen
						/>
					)}
					{(header || content) && (
						<S.TextWrapper>
							<Typography variant="h4" fontWeight="500" gutterBottom noWrap>
								{header}
							</Typography>
							<Typography variant="p3" color="var(--content-3)" gutterBottom noWrap>
								{content}
							</Typography>
						</S.TextWrapper>
					)}
				</S.ContentWrapper>
			</ModalContent>
			<ModalActions>
				<Button
					onClick={() => {
						handleCloseModal();
					}}
					label={'cancel'}
					variant="outline"
				/>

				<Button
					onClick={() => {
						window.open(actionUrl, '_blank', 'noopener,noreferrer');
						handleCloseModal();
					}}
					variant="blue"
					label={actionLabel}
				/>
			</ModalActions>
		</Modal>
	);
});

export default VideoPreviewModal;
